import { Skeleton } from 'components/ui/skeleton';

export type SkeletonChatsProps = {
  numberOfItems?: number;
};

export default function SkeletonChats(props: SkeletonChatsProps = { numberOfItems: 1 }) {
  const { numberOfItems } = props;

  return (
    <div className="flex-1">
      <div className="grid px-4">
        {[...Array(numberOfItems)].map((value, index) => (
          <div key={`skeleton-${index}`} className="flex items-center gap-4 py-4">
            <Skeleton className="size-10 shrink-0 rounded-full" />
            <div className="flex flex-1 flex-col gap-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/5" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
